import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/online-payments/report', request, null, {responseType: 'arraybuffer'})
}

export {get}
